// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"27a8048c","255":"c2666f67","262":"27a8048c","499":"696f9156","508":"196be9ad","577":"808ac746","610":"85b468ca","785":"abe10951","856":"1b288d97","968":"27a8048c"}[chunkId] + ".chunk.css";
};